// extracted by mini-css-extract-plugin
module.exports = {"brand-info":"brand_brand-info__SRF4l","share":"brand_share__4fJLf","more-tools":"brand_more-tools__3cmbG","phones":"brand_phones__KjaRZ"};